module.exports = __webpack_public_path__ + "images/stickers/pete-award.e341f6a4687bac4d86ab.png";